import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";
const logo = { url: "/media/investenergy-logo.png" };

const nav = [
  { to: "/", label: "Acasă" },
  { to: "/tematica", label: "Tematică" },
  { to: "/agenda", label: "Agendă" },
  { to: "/speakeri", label: "Speakeri" },
  { to: "/gala", label: "Gala Specialiștilor" },
  { to: "/parteneri", label: "Parteneri" },
] as const;

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-50 border-b bg-background/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-6 py-3">
          <Link
            to="/"
            className="shrink-0 transition-opacity duration-300"
            onClick={() => setOpen(false)}
          >
            <img src={logo.url} alt="InvesTenergy" className="h-12 w-auto md:h-14" />
          </Link>

          <nav className="hidden items-center gap-6 lg:flex">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                activeOptions={{ exact: item.to === "/" }}
                activeProps={{ className: "text-primary" }}
                inactiveProps={{ className: "text-foreground hover:text-primary" }}
                className="text-[15px] font-semibold tracking-tight transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition hover:opacity-90"
            >
              Contact &amp; Înregistrare
            </Link>
          </nav>


          <button
            type="button"
            aria-label="Meniu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
            className="relative grid size-10 place-items-center rounded-full bg-primary/10 text-primary transition hover:bg-primary/20 lg:hidden"
          >
            <Menu className="size-5" />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[100] lg:hidden"
          >
            <div
              className="absolute inset-0 bg-ink/60 backdrop-blur-sm"
              onClick={() => setOpen(false)}
            />

            <motion.nav
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              className="absolute bottom-0 right-0 top-0 w-[min(86vw,360px)] overflow-hidden bg-gradient-to-br from-ink via-ink to-primary/20 shadow-lift"
            >
              <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-energy via-glow to-primary/50" />
              <div className="pointer-events-none absolute -left-20 top-0 size-64 rounded-full bg-energy/15 blur-3xl" />

              <div className="relative flex h-full flex-col px-7 pb-8 pt-6">
                <div className="flex items-center justify-between">
                  <span className="font-display text-lg font-bold text-ink-foreground">
                    Meniu
                  </span>
                  <button
                    type="button"
                    aria-label="Închide meniul"
                    onClick={() => setOpen(false)}
                    className="grid size-10 place-items-center rounded-full border border-ink-foreground/20 text-ink-foreground transition hover:bg-ink-foreground/10"
                  >
                    <X className="size-5" />
                  </button>
                </div>

                <div className="mt-10 flex flex-1 flex-col gap-2">
                  {nav.map((item, i) => (
                    <motion.div
                      key={item.to}
                      initial={{ opacity: 0, x: 40 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.08 + i * 0.06, duration: 0.35 }}
                    >
                      <Link
                        to={item.to}
                        onClick={() => setOpen(false)}
                        activeOptions={{ exact: item.to === "/" }}
                        activeProps={{ className: "text-energy" }}
                        className="group flex items-center justify-between rounded-xl px-4 py-3.5 text-lg font-semibold text-ink-foreground/90 transition hover:bg-ink-foreground/5 hover:text-energy"
                      >
                        <span>{item.label}</span>
                        <ArrowRight className="size-5 -translate-x-2 opacity-0 transition group-hover:translate-x-0 group-hover:opacity-100" />
                      </Link>
                    </motion.div>
                  ))}
                </div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.45, duration: 0.35 }}
                >
                  <Link
                    to="/contact"
                    onClick={() => setOpen(false)}
                    className="flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3.5 text-center font-semibold text-primary-foreground shadow-glow transition hover:opacity-90"
                  >
                    Contact &amp; Înregistrare
                    <ArrowRight className="size-4" />
                  </Link>
                </motion.div>
              </div>
            </motion.nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
